import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';
import { useToast } from '@/hooks/use-toast';
import { cn } from '@/lib/utils';

interface ExportCsvButtonProps {
  /** Fetches every row matching the current filters and downloads the file. */
  onExport: () => Promise<void>;
  /** Extra classes, e.g. to size the button outside a filter grid. */
  className?: string;
}

export const ExportCsvButton = ({ onExport, className }: ExportCsvButtonProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const [isExporting, setIsExporting] = useState(false);

  const handleClick = async () => {
    setIsExporting(true);
    try {
      await onExport();
      toast({ title: t('DOWNLOAD_SUCCESSFUL') });
    } catch {
      toast({ variant: 'destructive', title: t('DOWNLOAD_FAILED') });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button
      variant="outline"
      className={cn('w-full', className)}
      onClick={handleClick}
      loading={isExporting}
      disabled={isExporting}
    >
      <Download className="size-4" />
      {t('DOWNLOAD')}
    </Button>
  );
};
